import { RestSlice } from '../../../../../redux/rest.slice';
import { IppPendingInvitation } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippPendingInvitationSlice = new RestSlice<IppPendingInvitation>(
	localizationService.getLocalizedString('ipp.authorityAccount.pendingInvitations'),
	Resource.IppPendingInvitations
);
export default ippPendingInvitationSlice.rests.reducer;
